import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { kyrgyzstanObjectBookingsStore } from 'entities/kyrgyzstan'

import { KyrgyzstanWebviewOwnerApi } from 'shared/api/kyrgyzstan/webview-owner'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import { ApplicationsList } from './ui/applications-list'
import { ApproveApplicationDialog } from './ui/approve-application-dialog'
import { RejectApplicationDialog } from './ui/reject-application-dialog'

import { useObjectApplications } from './lib/use-object-applications'
import s from './styles.module.scss'

interface Props {
  orderRequestsCount?: number
}

export const ObjectApplicationsWidget = ({ orderRequestsCount }: Props) => {
  const { t } = useTranslation()
  const { openDialog, closeDialog } = useDialogBottomSheet()
  const {
    applications,
    paginationTargetRef,
    reloadApplications,
    shouldHideSection,
    shouldShowInitialLoader,
    shouldShowPaginationLoader,
  } = useObjectApplications({ orderRequestsCount })

  const handleApproveConfirm = async (orderId: string) => {
    await KyrgyzstanWebviewOwnerApi.approveOrder(orderId)
    closeDialog()
    await reloadApplications()
    void kyrgyzstanObjectBookingsStore.refetchBookings()
  }

  const handleRejectConfirm = async (orderId: string) => {
    await KyrgyzstanWebviewOwnerApi.rejectOrder(orderId)
    closeDialog()
    await reloadApplications()
  }

  const handleApproveClick = (orderId: string) => {
    openDialog({
      child: (
        <ApproveApplicationDialog
          onConfirm={() => handleApproveConfirm(orderId)}
          onClose={closeDialog}
        />
      ),
      isDialog: false,
      borderRadius: 20,
      padding: [20, 8, 8],
    })
  }

  const handleRejectClick = (orderId: string) => {
    openDialog({
      child: (
        <RejectApplicationDialog
          onConfirm={() => handleRejectConfirm(orderId)}
          onClose={closeDialog}
        />
      ),
      isDialog: false,
      borderRadius: 20,
      padding: [20, 8, 8],
    })
  }

  if (shouldHideSection) {
    return null
  }

  return (
    <section
      className={s.section}
      aria-labelledby="object-applications-title"
    >
      <h2
        id="object-applications-title"
        className={clsx('bold-16', s.title)}
      >
        {t('kyrgyzstan_block.my_objects.applications.title')}
      </h2>

      <ApplicationsList
        applications={applications}
        paginationTargetRef={paginationTargetRef}
        shouldShowInitialLoader={shouldShowInitialLoader}
        shouldShowPaginationLoader={shouldShowPaginationLoader}
        onApprove={handleApproveClick}
        onReject={handleRejectClick}
      />
    </section>
  )
}
